var _circle, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#949699"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_1864_36286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2805 12.2803L11.6137 12.2945V7.71952C11.6137 7.3209 11.2928 7 10.8942 7C10.4957 7 10.1747 7.3209 10.1747 7.71952L10.1888 12.2805H5.71952C5.3209 12.2805 5 12.6014 5 13C5 13.3985 5.3209 13.7194 5.71952 13.7194H10.1817V18.2805C10.1817 18.6788 10.5026 19 10.9012 19C11.2999 19 11.6208 18.6788 11.6208 18.2805V13.7195H16.2805C16.6791 13.7195 17 13.3984 17 13C17 12.6012 16.6755 12.2803 16.2805 12.2803Z",
    fill: "#121212"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1864_36286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2805 11.2803L12.6137 11.2945V6.71952C12.6137 6.3209 12.2928 6 11.8942 6C11.4957 6 11.1747 6.3209 11.1747 6.71952L11.1888 11.2805H6.71952C6.3209 11.2805 6 11.6014 6 12C6 12.3985 6.3209 12.7194 6.71952 12.7194H11.1817V17.2805C11.1817 17.6788 11.5026 18 11.9012 18C12.2999 18 12.6208 17.6788 12.6208 17.2805V12.7195H17.2805C17.6791 12.7195 18 12.3984 18 12C18 11.6012 17.6755 11.2803 17.2805 11.2803Z",
    fill: "#949699"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1864_36286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1864_36286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.7978e610e1182ee34c0403c72ae8586e.svg";
export { ForwardRef as ReactComponent };